export default __webpack_public_path__ + "static/media/Group.a06d6040.png";